import React from 'react';

import styled from 'styled-components';

const StyledDiv = styled.div`
  background: #fafafa;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 14px;
  padding-right: 14px;
  width: fit-content;
  font-size: 13px;
  font-weight: 400;
  margin-top: 18px;
  margin-bottom: 18px;

  header {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  }
`;

export default (props: { account: accountT }) => (
  <StyledDiv>
    <header>
      To get the most out of PixelMe, connect the &nbsp;
      <a href={`/${props.account.id}/amazon/account`} target="_blank" rel="noreferrer">
        Amazon Selling Partner API{' '}
      </a>
    </header>{' '}
    We use this information to perform optimizations like pausing ads when a product is not available.
    <br />
    It also allows us to provide reports on organic sales increase, and TACOS calculations.
  </StyledDiv>
);
